module.exports = __webpack_public_path__ + "static/media/19ESCAP18.80beee97.jpg";